<template>
  <el-container>
    <el-main style="padding: 0">
      <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="workCenters/location">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="工作中心：">
              <el-input v-model.trim="filter.workCenterName" placeholder="请选择工作中心" readonly clearable>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectWorkCenter.open()"/>
              </el-input>
            </vm-search>
            <vm-search label="物料编号：">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="materialSn" align="left" label="序列号" width="160"/>
        <el-table-column
            prop="workCenterName"
            align="center"
            width="100"
            show-overflow-tooltip
            label="工作中心"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column
            prop="materialName"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="320"/>
        <el-table-column
            prop="specification"
            align="left"
            min-width="140"
            show-overflow-tooltip
            label="规格"/>
        <el-table-column prop="locationNo" align="center" width="120" label="库位编号"/>
        <el-table-column
            prop="locationName"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="库位名称"/>
        <el-table-column prop="quantity" align="center" label="库存" width="80"/>
        <el-table-column prop="unitName" align="center" label="单位" width="80"/>
        <el-table-column prop="materialLength" align="center" label="长" width="60"/>
        <el-table-column prop="materialWidth" align="center" label="宽" width="60"/>
        <el-table-column prop="materialHeight" align="center" label="高" width="60"/>
        <el-table-column prop="materialWeight" align="center" label="重" width="60"/>
        <el-table-column
            prop="note"
            align="left"
            label="备注"
            width="120"
            show-overflow-tooltip/>
        <el-table-column
            label="操作"
            align="center"
            fixed="right"
            prop="action"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="danger" @click="$refs.scrapEdit.open(scope.row)"> 报废 </el-button>
            <el-button type="primary" @click="$refs.feedEdit.open(scope.row)"> 送料 </el-button>
          </template>
        </el-table-column>
      </vm-table>
    </el-main>
    <work-center-select ref="selectWorkCenter" @select="selectWorkCenter"/>
    <feed-edit ref="feedEdit" @save-success="getList(1)"/>
    <scrap-edit ref="scrapEdit" @save-success="getList(1)"/>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import FeedEdit from "./FeedEdit";
  import ScrapEdit from "./ScrapEdit";
  export default {
    name: "LineLocationList",
    components: {
      VmTable,
      VmSearch,
      WorkCenterSelect,
      FeedEdit,
      ScrapEdit,
    },
    data() {
      return {
        filter: {
          workCenterName: "",
        },
      };
    },

    mounted() {
      this.$refs.vmTable.getList(1);
    },

    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      selectWorkCenter(row) {
        this.filter.workCenterName = row.workCenterName;
        this.filter.workCenterId = row.pkId;
      },
    },
  };
</script>
